var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "steps-box relative" }, [
    _c("div", { staticClass: "activeStep" }, [
      _c("i", { staticClass: "number normal inline-block" }, [_vm._v("1")]),
      _vm._v(" "),
      _c("span", {
        staticClass: "line",
        class: _vm.currentStep > 1 ? "lineActive" : ""
      }),
      _vm._v(" "),
      _c("p", { staticClass: "bold" }, [_vm._v(_vm._s(_vm.$t("8000083")))])
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.currentStep >= 2 ? "activeStep" : "" }, [
      _c("i", { staticClass: "number normal inline-block" }, [_vm._v("2")]),
      _vm._v(" "),
      _c("span", {
        staticClass: "line",
        class: _vm.currentStep > 2 ? "lineActive" : ""
      }),
      _vm._v(" "),
      _c("p", { staticClass: "bold" }, [_vm._v(_vm._s(_vm.$t("10000015")))])
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.currentStep >= 3 ? "activeStep" : "" }, [
      _c("i", { staticClass: "number normal inline-block" }, [_vm._v("3")]),
      _vm._v(" "),
      _c("span", {
        staticClass: "line",
        class: _vm.currentStep > 3 ? "lineActive" : ""
      }),
      _vm._v(" "),
      _c("p", { staticClass: "bold" }, [_vm._v(_vm._s(_vm.$t("8000084")))])
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.currentStep == 4 ? "activeStep" : "" }, [
      _c("i", { staticClass: "number normal inline-block" }, [_vm._v("4")]),
      _vm._v(" "),
      _c("p", { staticClass: "bold" }, [_vm._v(_vm._s(_vm.$t("8000085")))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-985c9062", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-985c9062","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compontents/freeZone/createSymbol/stepView.vue
// module id = Z8yz
// module chunks = 0